import { PopupInterface } from 'common/types/entities/popup-interface'
import { closePopup, showPopup } from 'publisher/actionsManagement'
import { PopupNew } from 'publisher/components/entities/popup-new'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import { PopupWrapperUi } from 'publisher/pages/ui/popup-wrapper-ui'
import { managementSelectors, useManagement, usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { closeCookieExists, setCloseCookie } from 'publisher/utils/cookie'
import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Overlay } from 'src/shared/components/overlay'

export const BlogOnExitPopup = () => {
  const popup = usePage(pageSelectors.getFirstOnExitPopup) as
    | PopupInterface
    | undefined
  const activePopupId = useManagement(managementSelectors.getActivePopupId)
  // we could have global popups available on all pages and posts
  const blogLayoutPageId = useBlog(blogSelectors.getBlogLayoutPageId)
  const isPopupActive = popup?.id === activePopupId
  const dispatch = useDispatch()

  const onLeaveHandler = useCallback(
    (event: MouseEvent) => {
      if (!popup || closeCookieExists(blogLayoutPageId, popup.id)) return

      if (
        event.clientY < 50 &&
        event.relatedTarget == null &&
        (event.target as HTMLElement).nodeName.toLowerCase() !== 'select'
      ) {
        dispatch(showPopup(popup.id))
        document.removeEventListener('mouseout', onLeaveHandler)
      }
    },
    [dispatch, blogLayoutPageId, popup],
  )

  useEffect(() => {
    if (popup && !closeCookieExists(blogLayoutPageId, popup.id)) {
      document.addEventListener('mouseout', onLeaveHandler)
    }
  }, [onLeaveHandler, blogLayoutPageId, popup])

  const handleClose =
    (closePopupId: string, closedDays: number | undefined) => () => {
      setCloseCookie(blogLayoutPageId, closePopupId, closedDays)
      dispatch(closePopup)
    }

  if (!isPopupActive) return null

  return (
    <React.Fragment>
      <PopupWrapperUi>
        <PopupNew
          entity={popup}
          closePopup={handleClose(popup.id, popup.closedDays)}
        />
      </PopupWrapperUi>
      <Overlay dark />
    </React.Fragment>
  )
}
